<template>
  <div class="news">
    <swiper :options="swiperOption">
      <swiper-slide
        v-for="(item, index) in data.news"
        :key="index"
        class="d-flex flex-column justify-content-between align-items-start"
      >
        <p class="date mb-2">{{item.text}}</p>
        <p class="ttl mb-2">{{item.title}}</p>
        <div class="cont mb-2">
          <p class="description">{{item.textarea | truncate(45, '...')}}</p>
        </div>
        <p class="link" @click="show(item)">ДАЛЕЕ</p>
      </swiper-slide>
      <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
      <div
        class="control-container d-flex justify-content-start align-items-center"
        slot="pagination"
      >
        <div class="swiper-pagination swiper-pagination-bullets"></div>
      </div>
    </swiper>

    <modal
      name="modal-news"
      :height="'auto'"
      :width="596"
      :adaptive="true"
      :classes="'main-modal'"
      @before-close="$root.beforeClose()"
    >
      <modal-news-component :content="modalData"></modal-news-component>
    </modal>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  props: {
    typeOfContent: String
  },
  data() {
    return {
      data: {},
      modalData: null,
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: "auto",
            slidesPerGroup: 1,
            spaceBetween: 18
          }
        },
        // scrollbar: {
        //   el: ".swiper-scrollbar",
        //   hide: false
        // }
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      }
    };
  },
  created() {
    axios
      .get(`${this.$root.routLink}/?ajax&act=${this.typeOfContent}`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons);
      });
  },
  methods: {
    show(item) {
      this.modalData = item;
      this.$modal.show("modal-news");
      this.$root.stopScroll = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  width: 100%;
  background-color: transparent;
  overflow: hidden;

  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    margin-right: -15px;
  }
  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    .swiper-slide {
      width: 80%;
    }
  }

  .ttl {
    font-weight: 500;
    font-size: 44px;
    line-height: 110.1%;
    color: $darkColor;
  }

  .swiper-container {
    overflow: visible;
    padding-bottom: 20px;

    .swiper-slide {
      height: 183px;
      max-width: 255px;
      background-color: #ffffff;
      border-radius: 6px;
      padding: 15px;
      .date {
        font-size: 14px;
        line-height: 150%;
        color: #7b7b7b;
      }
      .ttl {
        font-weight: 500;
        font-size: 14px;
        line-height: 110%;
        color: $mainFontColor;
      }
      .cont {
        width: 100%;
        height: 40px;
        overflow: hidden;
        .description {
          font-size: 12px;
          line-height: 110%;
          color: $mainFontColor;
        }
      }
      .link {
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        color: #005da4;
        transition: all 0.3 ease-in-out;
        cursor: pointer;
        &:hover {
          color: $activeColor;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.news {
  .swiper-wrapper {
    padding-bottom: 45px;
  }
  .swiper-container-horizontal > .swiper-scrollbar {
    background-color: #9c9c9c;
    height: 2px;
    border-radius: 0px;
    .swiper-scrollbar-drag {
      background-color: #ffffff;
      border-radius: 32px;
      height: 10px;
      margin-top: -4px;
    }
  }
  .control-container {
    padding: 0;
  }
  .control-container .swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
    background-color: #ffffff;
  }
  .control-container .swiper-pagination-bullet-custom {
    border: 2px solid #ffffff;
}
}
</style>